import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../types/global';
import applicationListSelectors from '../../modules/application/list/applicationListSelectors';
import { selectEnvironment } from '../../modules/global';
import { isKSACountry } from '../../config/countriesEnvironments';
import { addressVerificationStorage } from '../AddressVerification/addressVerificationStorage';
import { requestServiceAccess, UpgradeType } from '../../modules/avs';

export function useAddressVerificationPromotionBannerHandler(): {
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
  handleTryNow: () => void;
  handleReadDocumentation: () => void;
  isRequestButtonDisabled: boolean;
} {
  const dispatch = useDispatch();
  const environment = useTypedSelector(selectEnvironment);
  const application = useTypedSelector(
    applicationListSelectors.selectApplication,
  );

  const [isVisible, setIsVisible] = useState(() =>
    application?.id && !isKSACountry
      ? addressVerificationStorage.shouldShowBanner(environment, application.id)
      : false,
  );

  const [isRequestButtonDisabled, setIsRequestButtonDisabled] = useState(false);

  useEffect(() => {
    if (application?.id && !isKSACountry) {
      addressVerificationStorage.initializeBannerFirstSeen(
        environment,
        application.id,
      );
    }
  }, [environment, application?.id]);

  const handleTryNow = () => {
    if (application?.id && !isRequestButtonDisabled) {
      setIsRequestButtonDisabled(true);
      dispatch(
        requestServiceAccess({
          appToken: application.id,
          upgradeType: UpgradeType.ADDRESS_VERIFICATION,
        }),
      );
    }
  };

  const handleReadDocumentation = () => {
    if (application?.id) {
      window.open(
        'https://docs.leantech.me/docs/how-to-use-address-verification',
        '_blank',
      );
    }
  };

  return {
    isVisible,
    setIsVisible,
    handleTryNow,
    handleReadDocumentation,
    isRequestButtonDisabled,
  };
}